import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RecentTransactions = () => {
  const [transactions, setTransactions] = useState([
    {
      id: 1,
      type: 'buy',
      symbol: 'AAPL',
      name: 'Apple Inc.',
      quantity: 10,
      price: 175.43,
      total: 1754.30,
      date: new Date('2025-07-10T14:30:00'),
      status: 'completed'
    },
    {
      id: 2,
      type: 'sell',
      symbol: 'GOOGL',
      name: 'Alphabet Inc.',
      quantity: 2,
      price: 2847.63,
      total: 5695.26,
      date: new Date('2025-07-09T11:15:00'),
      status: 'completed'
    },
    {
      id: 3,
      type: 'buy',
      symbol: 'MSFT',
      name: 'Microsoft Corp.',
      quantity: 5,
      price: 378.85,
      total: 1894.25,
      date: new Date('2025-07-08T16:45:00'),
      status: 'pending'
    }
  ]);

  const navigate = useNavigate();

  const getTransactionIcon = (type) => {
    return type === 'buy' ? 'Plus' : 'Minus';
  };

  const getTransactionColor = (type) => {
    return type === 'buy' ? 'text-success' : 'text-destructive';
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'text-success';
      case 'pending': return 'text-warning';
      case 'failed': return 'text-destructive';
      default: return 'text-muted-foreground';
    }
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleViewAllTransactions = () => {
    navigate('/portfolio-management', { state: { tab: 'transactions' } });
  };

  const handleTransactionClick = (transaction) => {
    // Show transaction details
    alert(`Transaction Details:\n\nType: ${transaction.type.toUpperCase()}\nSymbol: ${transaction.symbol}\nQuantity: ${transaction.quantity}\nPrice: $${transaction.price}\nTotal: $${transaction.total}\nStatus: ${transaction.status}`);
  };

  const handleCancelTransaction = (transactionId) => {
    setTransactions(prev => 
      prev.map(t => 
        t.id === transactionId 
          ? { ...t, status: 'cancelled' }
          : t
      )
    );
  };

  return (
    <div className="card-elevated p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="Clock" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Recent Transactions</h3>
            <p className="text-sm text-muted-foreground">Latest portfolio activity</p>
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={handleViewAllTransactions}>
          <span className="text-sm">View All</span>
          <Icon name="ChevronRight" size={16} className="ml-1" />
        </Button>
      </div>

      <div className="space-y-4">
        {transactions.map((transaction) => (
          <div 
            key={transaction.id}
            className="flex items-center justify-between p-3 hover:bg-muted/30 rounded-lg transition-colors cursor-pointer group"
            onClick={() => handleTransactionClick(transaction)}
          >
            <div className="flex items-center space-x-3">
              <div className={`p-2 rounded-lg ${transaction.type === 'buy' ? 'bg-success/10' : 'bg-destructive/10'}`}>
                <Icon 
                  name={getTransactionIcon(transaction.type)} 
                  size={16} 
                  className={getTransactionColor(transaction.type)}
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2">
                  <p className="text-sm font-medium text-foreground">
                    {transaction.type.toUpperCase()} {transaction.symbol}
                  </p>
                  <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor(transaction.status)} bg-current bg-opacity-10`}>
                    {transaction.status}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground">
                  {transaction.quantity} shares @ ${transaction.price}
                </p>
                <p className="text-xs text-muted-foreground">
                  {formatDate(transaction.date)}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-2">
              <div className="text-right">
                <p className={`text-sm font-mono font-semibold ${getTransactionColor(transaction.type)}`}>
                  {transaction.type === 'buy' ? '-' : '+'}${transaction.total.toFixed(2)}
                </p>
              </div>
              
              {transaction.status === 'pending' && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCancelTransaction(transaction.id);
                  }}
                  className="h-8 w-8 opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <Icon name="X" size={14} className="text-destructive" />
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>

      {transactions.length === 0 && (
        <div className="text-center py-8">
          <Icon name="Activity" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No recent transactions</p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/stock-search-discovery')}
            className="mt-4"
          >
            Start Trading
          </Button>
        </div>
      )}
    </div>
  );
};

export default RecentTransactions;